import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';

// Componente personalizzato per l'opzione con checkbox per selezione multipla
const Option = ({ children, data, isSelected, ...props }) => (
  <components.Option {...props} isSelected={isSelected}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {props.isMulti && (
        <input 
          type="checkbox" 
          checked={isSelected} 
          onChange={() => null} 
          style={{ marginRight: '8px' }} 
        />
      )}
      {data.icon}
      {children}
    </div>
  </components.Option>
);

// Componente personalizzato per il valore selezionato con icona
const SingleValue = ({ children, data, ...props }) => (
  <components.SingleValue {...props}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {data.icon}
      {children}
    </div>
  </components.SingleValue>
);

// Componente personalizzato per il contenitore del gruppo
const GroupHeading = (props) => (
  <components.GroupHeading {...props}>
    <div style={{ 
      color: '#555',
      fontSize: '0.9em',
      fontWeight: 'bold',
      padding: '5px 0'
    }}>
      {props.children}
    </div>
  </components.GroupHeading>
);

const FSelect = (props) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Formatta le opzioni per react-select
  const formatOptions = (opts) => {
    return opts.map(opt => ({
      value: opt.id,
      label: opt.label,
      icon: opt.icon,
      ...opt // Mantieni altre proprietà per il groupBy
    }));
  };

  // Carica le opzioni (statiche o dinamiche)
  const loadOptions = async () => {
    setIsLoading(true);
    try {
      let loadedOptions = [];
      if (props.options) {
        loadedOptions = Object.keys(props.options).map(key => ({
          id: key, label: props.options[key]}));
      } else if (props.optionsquery) {//todo. magari
        //loadedOptions = await getDynamicOptions(props);
      }
      
      setOptions(formatOptions(loadedOptions));
    } catch (error) {
      console.error("Errore nel caricamento delle opzioni:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Carica le opzioni all'apertura e quando cambia il valore
  useEffect(() => {
    loadOptions();
  }, [props.value]);

  // Gestisce il cambio di valore
  const handleChange = (selectedOption) => {
    let newValue = null;
    
    if (props.isMultiple) {
      newValue = selectedOption ? selectedOption.map(option => option.value) : [];
    } else {
      newValue = selectedOption ? selectedOption.value : null;
    }
    
    props.onChange({
      target: {
        name: props.name,
        value: newValue,
        otherProps: selectedOption
      }
    });
  };

  // Determina il valore corrente formattato per react-select
  const getCurrentValue = () => {
    if (!options.length) return props.isMultiple ? [] : null;
    
    if (props.isMultiple) {
      const values = props.value || [];
      return options.filter(option => values.includes(option.value));
    } else {
      return options.find(option => option.value === props.value) || null;
    }
  };

  // Funzione di raggruppamento per le opzioni
  const getGroupedOptions = () => {
    if (!props.optionsGroupBy) return options;
    
    const groupedOptions = [];
    const groups = {};
    
    options.forEach(option => {
      const groupKey = option[props.optionsGroupBy];
      if (!groups[groupKey]) {
        groups[groupKey] = {
          label: groupKey,
          options: []
        };
        groupedOptions.push(groups[groupKey]);
      }
      groups[groupKey].options.push(option);
    });
    
    return groupedOptions;
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: props.error ? '#D32F2F' : provided.borderColor,
      boxShadow: state.isFocused ? (props.error ? '0 0 0 1px #D32F2F' : provided.boxShadow) : 'none',
      '&:hover': {
        borderColor: props.error ? '#D32F2F' : provided.borderColor
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999
    })
  };

  return (
    <div className="select-container input-form">
      <label className={`select-label`}>
        {props.label} {props.required && !props.disabled ? '*' : ''}
      </label>
      <div className='form-group'>
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            isMulti={props.isMultiple}
            options={getGroupedOptions()}
            value={getCurrentValue()}
            onChange={handleChange}
            isDisabled={props.disabled}
            isLoading={isLoading}
            placeholder={props.placeholder || "Seleziona..."}
            isClearable
            components={{
            Option,
            SingleValue,
            GroupHeading
            }}
            onBlur={props.onBlur}
            styles={customStyles}
            noOptionsMessage={() => "Nessuna opzione disponibile"}
        />
        {props.helperText && (
            <div className={`helper-text ${props.error ? 'error' : ''}`}>
            {props.helperText}
            </div>
        )}
      </div>
      
    
    </div>
  );
};

export default FSelect;